import React, {useState, useEffect, useRef, useContext} from 'react';
import {errorStatusContext} from '../../contexts/ErrorStatusContext';
import {loadingPauseContext} from '../../contexts/LoadingPauseContext';
import {fetchApi} from '../../utils/ApiHelper';
import {HTTP_METHODS, BLOOD_SUGAR_LEVEL} from '../../utils/URLConstants';
import {useNavigation} from '@react-navigation/native';

import UI from './ui';

const ViewCompleteHistory = ({route, homeMode}) => {
  // DLog(`min: ${hypo} max: ${hyper}`);
  const navigation = useNavigation();
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [notes, setNotes] = useState({data: []});
  const [range, setRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    numDays: homeMode ? 1 : 7,
  });
  const firstRender = useRef(true); //required so that we dont run the getData API twice

  const lpc = useContext(loadingPauseContext);
  const esc = useContext(errorStatusContext);

  // DLog('range is',range)

  useEffect(() => {
    // DLog('range update useEffect called with range as', range);
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getData is re-created each render; refetch is intentionally keyed to range changes only
  }, [range]);

  useEffect(() => {
    //compute endDate if numDays updates, keep starting as the same
    setNumDays(range.numDays);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only initialization of the derived end date; setNumDays is re-created each render
  }, []);

  const setNumDays = numDays => {
    //when setting numdays, also update the end date
    let tempRange = {...range};
    tempRange.numDays = numDays;
    let currentEndDate = new Date(range.startDate);
    currentEndDate.setDate(currentEndDate.getDate() - numDays + 1);
    tempRange.endDate = currentEndDate;
    // DLog('updated range is', tempRange);
    setRange(tempRange);
  };

  const getData = () => {
    let toDate = new Date(range.startDate);
    toDate.setHours(23, 59, 59, 999);
    toDate = toDate.toISOString();
    let fromDate = new Date(range.endDate);
    fromDate.setHours(0, 0, 0, 0);
    fromDate = fromDate.toISOString();

    let params = {fromDate: fromDate, toDate: toDate};

    //add to params if home mode is true
    if (homeMode) {
      params.homeMode = true;
    }

    // DLog('params', HTTP_METHODS.GET,params);
    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.GET, BLOOD_SUGAR_LEVEL, null, params)
      .then(res => {
        //DLog('got data', res.status, res.data.data);
        if (res.status === 200) {
          setNotes(res.data.data);
        } //setReadings(res.data.data);
        else setNotes({data: []});
        lpc.setVisible(false);
      })
      .catch(e => {
        // DLog('getData Error', e);
        setNotes({data: []});
        if (e != 'No measurement records found') esc.showError(e);
        lpc.setVisible(false);
      });
  };

  const UIparams = {
    route,
    homeMode,
    navigation,
    range,
    setRange,
    setNumDays,
    calendarVisible,
    setCalendarVisible,
    notes,
    getData,
  };

  return <UI {...UIparams} />;
};

export default ViewCompleteHistory;
